import { useSystemLanguageValue } from './business/system/useSystem';

export const useBusinessDocument = () => {
  const lang = useSystemLanguageValue();

  if (lang === 'zh-CN') {
    return {
      privacyPolicy: import.meta.env.VITE_PRIVACY_POLICY_JIONGXIN,
      serviceAgreement: import.meta.env.VITE_SERVICE_AGREEMENT_JIONGXIN,
      cookiePolicy: undefined,
    };
  }

  if (lang === 'id') {
    return {
      privacyPolicy: import.meta.env.VITE_PRIVACY_POLICY_JOLECT_ID,
      serviceAgreement: import.meta.env.VITE_SERVICE_AGREEMENT_JOLECT_ID,
      cookiePolicy: import.meta.env.VITE_COOKIE_POLICY_JOLECT,
    };
  }

  if (lang === 'vi') {
    return {
      privacyPolicy: import.meta.env.VITE_PRIVACY_POLICY_JOLECT_VI,
      serviceAgreement: import.meta.env.VITE_SERVICE_AGREEMENT_JOLECT_VI,
      cookiePolicy: import.meta.env.VITE_COOKIE_POLICY_JOLECT,
    };
  }

  if (lang === 'pt') {
    return {
      privacyPolicy: import.meta.env.VITE_PRIVACY_POLICY_JOLECT_PT,
      serviceAgreement: import.meta.env.VITE_SERVICE_AGREEMENT_JOLECT_PT,
      cookiePolicy: import.meta.env.VITE_COOKIE_POLICY_JOLECT,
    };
  }

  if (lang === 'th') {
    return {
      privacyPolicy: import.meta.env.VITE_PRIVACY_POLICY_JOLECT_TH,
      serviceAgreement: import.meta.env.VITE_SERVICE_AGREEMENT_JOLECT_TH,
      cookiePolicy: import.meta.env.VITE_COOKIE_POLICY_JOLECT,
    };
  }

  if (lang === 'tl') {
    return {
      privacyPolicy: import.meta.env.VITE_PRIVACY_POLICY_JOLECT_FIL,
      serviceAgreement: import.meta.env.VITE_SERVICE_AGREEMENT_JOLECT_FIL,
      cookiePolicy: import.meta.env.VITE_COOKIE_POLICY_JOLECT,
    };
  }

  if (lang === 'es') {
    return {
      privacyPolicy: import.meta.env.VITE_PRIVACY_POLICY_JOLECT_ES,
      serviceAgreement: import.meta.env.VITE_SERVICE_AGREEMENT_JOLECT_ES,
      cookiePolicy: import.meta.env.VITE_COOKIE_POLICY_JOLECT,
    };
  }

  return {
    privacyPolicy: import.meta.env.VITE_PRIVACY_POLICY_JOLECT,
    serviceAgreement: import.meta.env.VITE_SERVICE_AGREEMENT_JOLECT,
    cookiePolicy: import.meta.env.VITE_COOKIE_POLICY_JOLECT,
  };
};
